export const USER_PROFILE_FILTER_ARGS: string[] = ['ADMIN','PROFILE', 'PRODUCT_NEWS']
export const PRIMARY_HOST_DOMAIN: string = '.verisk.com'
export const LOCAL_STORAGE_ELIGIBLE_PRODUCTS: string = 'eligibleProducts';
export const CONFIG_MFA: string = 'CONFIGURE_MFA';
export const USER_PROFILE_PASSWORD:string = 'C_PASSWORD';
export const HTTP_STATUS_CODE = {
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
};